import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useLayoutHeaderStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: 'white',
      height: 64,
      justifyContent: 'center',
      paddingTop: 3
    },

    title: {
      fontWeight: 600,
      display: 'none',
      cursor: 'pointer',

      [theme.breakpoints.up('md')]: {
        display: 'block'
      }
    },

    rect: {
      height: 4,
      width: 4,
      backgroundColor: 'currentColor',
      display: 'none',
      borderRadius: '50%',
      margin: '0 8px 0 5px',

      [theme.breakpoints.up('md')]: {
        display: 'block'
      }
    },

    lang: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 4
    },

    btnRu: {
      fontFamily: 'Montserrat',
      fontSize: 16,
      textTransform: 'none',
      minWidth: 40,
      minHeight: 30,
      marginLeft: 30,
      [theme.breakpoints.down(1390)]: {
        marginLeft: 5
      }
    },

    btnEng: {
      fontFamily: 'Montserrat',
      fontSize: 16,
      textTransform: 'none',
      minWidth: 50,
      minHeight: 30,
      marginRight: 30,
      [theme.breakpoints.down(1390)]: {
        marginRight: 5
      }
    },

    linkDivider: {
      height: 23,
      borderRight: '1px solid #9E9E9E'
    },

    buttonAuth: {
      marginLeft: 10
    }
  })
)
